import main from "./main.json";
import common from "./common.json";
const ar = {
  ...main,
  ...common,
};
export default ar;
